import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {ModalFooter} from "../Components/BookingModalShell.jsx";

export function FindingDriverPolicies({setStep, closeModal}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep="bookingReceived" showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <div className="hopn-instruction-layout modalPages-spacing">
                <h3>Terms & Conditions 🚨</h3>
                <h6>Booking Received — Finding Your Driver</h6>
                <p>We've received your booking and are working to match you with the right vehicle and a professional driver. You'll receive a confirmation once your ride is locked in.</p>
                <div className="important-note">
                    <h6>⚠  Important:</h6>
                    <p>Your booking is not yet confirmed. Until a driver accepts and your ride is confirmed, hop'n cannot guarantee pickup or be held responsible for any missed flights, delays, or losses related to timing. We appreciate your patience — we're doing our best to serve you as quickly as possible.</p>
                </div>
                <div className="spacial-layout">
                    <b>Pending Bookings Disclaimer:</b>
                    <ul>
                        <li>A booking submitted through the hop'n platform is considered pending until it is accepted by a driver and marked as confirmed. During this pending period, hop'n does not guarantee pickup or service delivery.</li>
                        <li>Hop'n shall not be liable for any losses, including but not limited to missed flights, appointments, or business impacts, resulting from unconfirmed or delayed bookings. We recommend all users book in advance to allow sufficient time for matching and confirmation</li>
                    </ul>
                </div>
            </div>
            <ModalFooter>
                <button onClick={() => setStep('bookingReceived')} className="bg-(--text-primary) text-white text-center rounded-full w-full p-3 hover:opacity-80">Okay</button>
            </ModalFooter>
        </>
    );
}
export default FindingDriverPolicies;
